import { useState } from "react";
import { updateLogs, updateTags } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

const tagStyle: Record<string, string> = {
  地址更新: "bg-accent-100 text-accent-800",
  公告提醒: "bg-primary-100 text-primary-800",
  使用技巧: "bg-secondary-100 text-secondary-900",
};

export default function UpdateLog() {
  const [activeTag, setActiveTag] = useState("全部");

  const filtered = activeTag === "全部" ? updateLogs : updateLogs.filter((item) => item.tag === activeTag);

  return (
    <section id="updates" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="地址与通知记录"
            title="最新地址动态"
            desc="地址更换、公告提醒与使用技巧会按时间记录在这里。按下方的分类标签即可筛选你关心的内容。"
          />
          <div className="flex flex-wrap gap-2">
            {updateTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => setActiveTag(tag)}
                className={
                  activeTag === tag
                    ? "whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 font-label text-sm font-medium text-background-50"
                    : "whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                }
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="flex gap-4 rounded-lg border border-background-200 bg-background-100/70 p-4 transition-colors hover:border-primary-200 md:p-5"
            >
              <div className="flex w-16 shrink-0 flex-col items-center">
                <span className="font-heading text-xl font-bold text-foreground-950">{item.date.slice(8, 10)}</span>
                <span className="font-label text-[11px] text-foreground-500">{item.date.slice(0, 7)}</span>
                <span className="mt-2 h-8 w-px bg-background-300"></span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`rounded-full px-2.5 py-0.5 font-label text-[11px] font-medium ${tagStyle[item.tag]}`}>
                    {item.tag}
                  </span>
                  <span className="font-label text-[11px] text-foreground-500">{item.date}</span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="mt-8 rounded-lg border border-background-200 bg-background-100 px-4 py-6 text-center text-sm text-foreground-500">
            该分类下暂时没有记录。
          </p>
        ) : null}
      </div>
    </section>
  );
}